import { matchRoute } from './match.js';

const LEGACY_PREFIX = '/party';

/**
 * Links to the old `/party/<slug>` URL space are already out in the world — on
 * phones, in chats, on printed QR codes — so they keep working by being
 * rewritten to the top-level party path they now live at.
 */
export const canonicalPath = (path: string): string => {
  const dj = matchRoute(`${LEGACY_PREFIX}/:slug/dj/:channelId`, path);
  if (dj?.['slug'] !== undefined && dj['channelId'] !== undefined) {
    return `/${dj['slug']}/dj/${dj['channelId']}`;
  }

  const suggest = matchRoute(`${LEGACY_PREFIX}/:slug/suggest`, path);
  if (suggest?.['slug'] !== undefined) {
    return `/${suggest['slug']}/suggest`;
  }

  const party = matchRoute(`${LEGACY_PREFIX}/:slug`, path);
  if (party?.['slug'] !== undefined) {
    return `/${party['slug']}`;
  }

  return path;
};
